import { render, staticRenderFns } from "./DemoLoginConfig.vue?vue&type=template&id=07d27f0e"
import script from "./DemoLoginConfig.vue?vue&type=script&lang=js"
export * from "./DemoLoginConfig.vue?vue&type=script&lang=js"
import style0 from "./DemoLoginConfig.vue?vue&type=style&index=0&id=07d27f0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports